/* eslint-disable camelcase */
// periods
import React from 'react';
import {
    gql, useQuery, useReactiveVar,
} from '@apollo/client';
import { deliveryIDVar } from 'app/apollo/reaction';
import { DELIVERY_BASKET_QUERY } from 'app/graphql/network/deliveryCart';

const initial = { cart: null };

export const useDeliveryBasketData = (
    // query = CART_DATA_FOR_MENU_QUERY,
    query = DELIVERY_BASKET_QUERY,
    message = 'app:hook:useDeliveryBasketData',
    fetchPolicy = 'cache-first',
) => {
    const isDeliveryBasket = window.location.pathname.includes('app/delivery');
    const VAR_Delivery_ID = useReactiveVar(deliveryIDVar);
    const URL_Delivery_ID = window.location.pathname
        .split('/')
        .find((e) => Boolean(e) && !Number.isNaN(Number(e)));

    const { data } = useQuery(query, {
        variables: {
            deliveryId: VAR_Delivery_ID || URL_Delivery_ID,
        },
        context: {
            message,
        },
        fetchPolicy,
        skip: !isDeliveryBasket,
    });

    return data || initial;
};
